import VendaFormaPagamento from './VendaFormaPagamento';

export default VendaFormaPagamento;
